<template>
  <div>
    <div v-if="currentPosiciones || currentPosiciones.length > 0" class="row px-4 card-columns">
      <div
        v-for="(item, index) in currentPosiciones"
        :key="index"
        class="col-sm-12 col-lg-6 py-3 text-center"
      >
        <!-- Card para activos -->
        <div
          v-if="item.estatus"
          :class="[getCardClass(item), 'rounded_pill shadow_inset']"
        >
          <div class="row card-body px-4 py-4">
            <div class="col-12 d-flex align-items-center">
              <h6 class="text-white text-center">{{ item.barra }}</h6>
            </div>
            <div class="col-12 d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between align-items-center">
                <i :class="getIconClass(item)" style="color: #FFF; font-size: 32px;"></i>
                <h2 class="text-white">
                  <b>
                    &nbsp;- {{ item.posicion }}
                    <div class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>&nbsp;
                  </b>
                </h2>
              </div>
              <h4 class="text-white text-truncate">{{ getTipoTexto(item) }}</h4>
            </div>
            <div class="col-12 mt-4">
              <h5 class="font-weight-bold mb-2 text-white">{{ item.descripcion }}</h5>
            </div>
            <div class="col-12 d-flex justify-content-center pt-3">
              <button class="btn btn-md btn-outline-light" @click="editClickNivel(item)">
                <i class="fa fa-edit"></i> Editar Posición
              </button>
            </div>
          </div>
        </div>

        <!-- Card para inactivos -->
        <div
          v-else
          class="red_gradient_bg rounded_pill shadow_inset"
        >
          <div class="row card-body px-4 py-4">
            <div class="col-12 d-flex align-items-center">
              <h6 class="text-white text-center">{{ item.barra }}</h6>
            </div>
            <div class="col-12 d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between align-items-center">
                <i :class="getIconClass(item)" style="color: #FFF; font-size: 32px;"></i>
                <h2 class="text-white">
                  <b>
                    &nbsp;- {{ item.posicion }}
                    <div class="status-pill red" data-title="Inactivo" data-toggle="tooltip"></div>&nbsp;
                  </b>
                </h2>
              </div>
              <h4 class="text-white text-truncate">{{ getTipoTexto(item) }}</h4>
            </div>
            <div class="col-12 mt-4">
              <h5 class="font-weight-bold mb-2 text-white">{{ item.descripcion }}</h5>
            </div>
            <div class="col-12 d-flex justify-content-center pt-3">
              <button class="btn btn-md btn-outline-light" @click="editClickNivel(item)">
                <i class="fa fa-edit"></i> Editar Posición
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!currentPosiciones || currentPosiciones.length < 1" class="row px-4 py-4">
      <div class="col-12 text-center">
        <h6 class="py-4 text-muted text-center">No se han encontrado posiciones asignadas a este nivel</h6>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    currentPosiciones: {},
  },
  methods: {
    getCardClass(item) {
      if (item.tipo_posicion == 'C') return 'cyan_gradient_bg';
      if (item.tipo_posicion == 'E' && item.para_contenedor == 0) return 'orange_gradient_bg';
      if (item.tipo_posicion == 'E' && item.para_contenedor == 1) return 'green_gradient_bg';
      if (item.tipo_posicion == 'P') return 'purple_gradient_bg';
      return 'default_bg';
    },
    getIconClass(item) {
      if (item.tipo_posicion == 'C') return 'fas fa-dolly-flatbed';
      if (item.tipo_posicion == 'E' && item.para_contenedor == 0) return 'fas fa-truck-loading';
      if (item.tipo_posicion == 'E' && item.para_contenedor == 1) return 'fa fa-truck';
      if (item.tipo_posicion == 'P') return 'fas fa-pallet';
      return 'fas fa-question';
    },
    getTipoTexto(item) {
      if (item.tipo_posicion == 'C') return 'CARRITO';
      if (item.tipo_posicion == 'E' && item.para_contenedor == 0) return 'ESTACIÓN';
      if (item.tipo_posicion == 'E' && item.para_contenedor == 1) return 'RAMPA CAR/DES';
      if (item.tipo_posicion == 'P') return 'POSICIÓN';
      return 'DESCONOCIDO';
    },
    editClickNivel(item) {
      this.$emit('postionEditItem', item);
    },
  }
};
</script>
